// extracted by mini-css-extract-plugin
module.exports = {"heading":"Title_heading__32uND"};